<ion-modal [isOpen]="isOpen" (didDismiss)="onDismiss()">
  <ng-template>
    <ion-content class="image-preview-content">
      <div class="image-container">
        <img [src]="imageSrc" class="preview-image" (click)="$event.stopPropagation()" />
        <div class="close-button" (click)="onDismiss()">
          <img src="assets/img/white-close.svg" />
        </div>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
